<template>
    <v-app
        :key="$store.state.ThemesStore.currentTheme"
        :background="$vuetify.theme.currentTheme.secondary">
        <router-view></router-view>
        <SnackbarHandler/>
    </v-app>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import SnackbarHandler from '@/components/SnackbarsHandler'

@Component({
    components: {
        SnackbarHandler
    }
})
export default class App extends Vue {
    get userAuth () {
        return this.$store.state.AuthStore.auth
    }

    beforeMount () {
        const localStorageAuth = localStorage.getItem('auth')
        if (localStorageAuth) this.$store.commit('updateAuth', JSON.parse(localStorageAuth))
    }

    mounted () {
        if (this.$store?.state?.AuthStore?.auth?.user?.userId) this.$store.dispatch('getUserLogued')

        document.onreadystatechange = () => {
            if (document.readyState === 'complete') {
                const loadingElement = document.getElementById('initial-loader')
                loadingElement.classList.add('close')
            }
        }
    }
}
</script>

<style lang="scss">
.loading-container  {
    min-height: 100vh;
}
th {
    background: #332E2E;
}
</style>
